import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import Expenses from './Expenses';

export default compose(withRouter)(Expenses);
